<template>
  <div v-if="body_show" :class="[!editWorkShow?'bodys':'',bid!=1?'body-on':'']">
    <!-- 海报显示 -->
    <h2 v-if="title" class="report-title text-center">{{user_list.nickname}}的{{title}}报告</h2>
    <div v-if="report" class="report_main">
      <div v-for="(item,index) in report" :key="index">
        <div v-if="item.compelete" class="report-box">
          <img :src="item.imgurl" class="report_img" @click="img_preview(index)" />
          <h5 v-if="item.compelete" >*长按卡片可保存</h5>
        </div>
        <div v-else class="report-box">
          <h2>{{item.title}}</h2>
          <img src="@a/ta_report_t.png" class="report_img" @click="img_preview(index)" />
          <h5 class="hei" ></h5>
          <h3 v-if="index==0">任务一的报告未完成！</h3>
          <h3 v-if="index==1">任务二的报告未完成！</h3>
          <h3 v-if="index==2">任务三的报告未完成！</h3>
        </div>

      </div>
    </div>
    <div v-else class="pb50 text-center">
      暂未提交报告
    </div>
    <!-- 批改作业 -->
    <div v-if="editWorkShow" class="edit-work-box">
        <h2 class="title">批改作业</h2>
        <div class="project-score">
            <h2 class="lable">项目得分</h2>
            <label for="S" :class="{'on':project_score=='S'}">S
                <input hidden type="radio" v-model="project_score" value="S" id="S">
            </label>
            <label for="A" :class="{'on':project_score=='A'}">A
                <input hidden type="radio" v-model="project_score" value="A" id="A">
            </label>
            <label for="B" :class="{'on':project_score=='B'}">B
                <input hidden type="radio" v-model="project_score" value="B" id="B">
            </label>
        </div>
        <h2 class="lable">项目评语</h2>
        <div class="project-evaluation-box">
          <textarea  v-model="project_evaluation" rows="5" placeholder="请在此输入针对学员项目的项目点评评语"></textarea>
          <span>字数：{{project_evaluation.length}}</span>
        </div>
        <button @click="validationHandle?submitHandle():''" :class="['edit-btn',validationHandle?'on':'']">提交批改</button>
    </div>
    <!--  -->
    <button v-show="!editWorkShow && bid==1" @click="report_text==''?editWorkHandle():work_show=true" class="edit-work-btn">{{validationHandle?'修改批改':'批改作业'}}</button>
    <!-- 批改作业弹窗 -->
    <van-popup class="pub_alert" v-model="work_show">
        <div class="confirm_box">
            <h2>此项目的{{report_text}}还未完成，您确定要批改吗？</h2>
            <div class="btn_group">
                <a class="cancel on" href="javascript:;" @click="work_show=false" >取消</a>
                <a class="confirm" href="javascript:;" @click="editWorkHandle" >确认</a>
            </div>
        </div>
    </van-popup>
  </div>
</template>
<script>
import { getWork,setWork } from "@/api/assistant";
import { shareCon } from "@/utils/wxconfig";
  export default {
    data() {
      return {
        bid:null,
        report:[],
        body_show: false,
        title: "",
        user_list:{},
        work_show:false,
        project_evaluation:'',
        project_score:'',
        editWorkShow:false,
        report_text:''
      }
    },
    computed:{
      // 验证非空
      validationHandle(){
          if(!this.project_score || !this.project_evaluation){
            return false
          }
          return true;
      }
    },
    methods: {
      submitHandle(){
        setWork({
          uid:this.$route.query.uid,
          cid:this.$route.query.cid,
          cpid:this.$route.query.cpid,
          assist_remark:this.project_evaluation,
          score:this.project_score
        }).then((data)=>{
          this.editWorkShow = false;
          this.$toast({
            message:data.msg,
            onClose:()=>{
              this.$router.go(-1)
            }
          });
        });
      },
      // 显示修改点评
      editWorkHandle(){
        this.work_show = false;
        this.editWorkShow = true;
        this.$nextTick(()=>{
          window.scrollTo(0, document.body.scrollHeight );
        });
      },
      pullData() {
        getWork(this.$route.query).then((data)=>{
          if(data.code==10002){
            this.$toast(data.data.msg);
            return
          }
            // this.report = data.resultmap;{{report_text}}
            let str = "";
            let list = [];
            for(let key in data.resultmap){
              let obj = {};
              obj['compelete'] = data.resultmap[key].compelete;
              obj['imgurl'] = data.resultmap[key].imgurl;
              obj['title'] = data.resultmap[key].name;
              if(!data.resultmap[key].compelete){
                if(key=='t1'){
                  str +='任务一和';
                }else if(key=='t2'){
                  str +='任务二和';
                }else if(key=='t3'){
                  str +='任务三和';
                }
              }
              list.push(obj);
            }
            this.report_text = str.replace(/和$/ig, '');
            this.bid= data.bid;
            this.report = list;
            this.title = data.title;
            this.user_list = data.user;
            if(data.assist){
              this.project_evaluation  = data.assist.assist_remark || '';
              this.project_score  = data.assist.score;
            }
            this.setTitle();
            this.body_show = true;
        });
      },
      img_preview(num) {
        ImagePreview({
          images: this.report,
          startPosition: num,
          showIndex: false,
          onClose() {
            // do something
          }
        });
      },
			setTitle(){
				// let title = this.$route.query.name;
				document.title = decodeURI(this.title);
			}
    },
    created() {
      this.pullData();
      shareCon("course",this);
    },
    watch:{
      project_evaluation(newVal,oldVal){
        if(newVal && newVal.length > 300) {
          this.project_evaluation = newVal.slice(0, 300);
          this.$toast('最多只能输入'+300+'个字。/(ㄒoㄒ)/~~！');
		    }
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import "@s/remChange.scss";
  .bodys{
    padding-bottom: 107px;
    background-color: #fff;
  }
  .body-on{
    padding-bottom: 27px !important;
  }
  .report-title{
    font-size: 34px;
    line-height: 120px;
    background: #f0f0f0;
    font-weight: bold;
  }
  .pb50{
    padding: 100px 0;
    font-size: 30px;
  }
  .color-blue{
    color: #0C1D66;
  }
  .text-bold{
    font-weight: bold;
  }
  .text-break{
    word-break:break-all;
  }
  .msg-font{
    font-size: 25px;
    color: #333;
    line-height: 30px;
  }
  .pd_auto{
    padding: 30px;
  }
  // 展示图
  .report_main {
    background: #fff;
    text-align: left;
    .report-box{
      position: relative;
      h2{
        position: absolute;
        font-size: 40px;
        color: #FFFFFF;
        font-weight: bold;
        top: 40px;
        left: 50%;
        transform: translateX(-50%);
      }
      h3{
        position: absolute;
        z-index: 2;
        top:50%;
        left: 50%;
        transform: translate(-50%,-50%);
        text-align: left;
      }
    }
    img.report_img {
      width: 100%;
      height: auto;
      vertical-align: middle;
      margin-top: changeRem(.6)+px;
    }
    h5 {
      color: #333;
      font-size: changeRem(.48)+px;
      padding-right: changeRem(.6)+px;
      margin-top: changeRem(.2)+px;
      text-align: right;
      width: 100%;
    }
    .hei{
      height: 40px;
      background-color: #ffffff;
    }
  }
  .edit-work-btn{
    position: fixed;
    left: 0;
    bottom: 0;
    font-size: 32px;
    z-index: 10;
    width: 100%;
    line-height: 80px;
    color: #fff;
    background-color: #EB5032;
    border: none;
  }
  .edit-btn{
    position: fixed;
    left: 0;
    z-index: 10;
    bottom: 0;
    font-size: 32px;
    width: 100%;
    line-height: 80px;
    color: #fff;
    background-color: #CCCCCC;
    border: none;
  }
  .edit-btn.on{
    background-color: #EB5032;
  }
  .pub_alert{
      font-size: 34px;
      text-align: left;
      .confirm_box h2{
        padding:44px 32px;
      }
  }
  .edit-work-box{
      padding: 0 30px;
      margin: 62px auto 160px;
    h2{
      font-size: 34px;
      color: #333333;
      line-height: 1;
    }
    h2.title{
      padding-bottom: 30px;
      border-bottom: 1px solid #CCCCCC;
    }
    h2.lable{
      margin:60px auto 20px;
      color: #EB5032;
    }
    .project-score label{
        text-align: center;
        display: inline-block;
        width: 120px;
        line-height: 70px;
        color: #fff;
        background-color:#CCCCCC;
        border-radius:8px;
        margin-right: 40px;
        font-size: 34px;
    }
    .project-score label.on{
        background-color: #EB5032;
    }
    .project-evaluation-box{
      position: relative;
      textarea{
        width: 100%;
        border-radius:8px;
        border: 0;
        font-size: 26px;
        color: #333333;
        padding: 20px;
        resize: none;
      }
      span{
        position: absolute;
        right: 20px;
        bottom: 20px;
        font-size: 16px;
      }
    }
  }
</style>